export { default as ProxyFundOptions } from './ProxyFundOptions';
